import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import DataTableMonth from '@/components/datatable/DataTableMonth.vue';
import PluralTranslator from '@/components/PluralTranslator.vue';
import EmployeeWithStatus from '@/components/salary/EmployeeWithStatus.vue';
import PayrollTableActions from '@/components/salary/PayrollTableActions.vue';
import PayslipTableActions from '@/components/salary/PayslipTableActions.vue';
import type { Payroll } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Payroll>[] = [
    {
        accessorKey: 'id',
        enableColumnFilter: false,
    },
    {
        accessorKey: 'year',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.year',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'month',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.month',
            }),
        cell: ({ row }) => {
            return h(DataTableMonth, {
                month: row.original.month,
            });
        },
        filterFn: 'valueInArray',
        meta: {
            filterType: 'month',
        },
    },
    {
        accessorKey: 'type_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.type',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'num_of_employees',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.num_of_employees',
            }),
        cell: ({ row }) => {
            return h(PluralTranslator, {
                count: row.original.num_of_employees,
                translationKey: 'salary.sheets.employees_plural',
            });
        },
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'approved_by_name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.approved_by',
            }),
        cell: ({ row }) => {
            return h(EmployeeWithStatus, {
                employeeName: row.original.approved_by_name,
            });
        },
    },
    {
        accessorKey: 'payslip_approved_by_all_approvers',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.payslip_approved_by',
            }),
        cell: ({ row }) => {
            return h(EmployeeWithStatus, {
                employeeName: row.original.payslip_approved_by_all_approvers,
            });
        },
    },
    {
        accessorKey: 'last_reminded_at',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.last_reminded_at',
            }),
        meta: {
            filterType: 'dateRange',
        },
    },
    {
        accessorKey: 'payslip_actions',
        enableHiding: false,
        enableColumnFilter: false,
        enableSorting: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.payslip_actions',
            }),
        cell: ({ row }) => {
            return h(PayslipTableActions, {
                payslip: row.original.pay_slip,
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'payrolls.existing.headers.actions',
            }),
        cell: ({ row }) => {
            return h(PayrollTableActions, {
                payroll: row.original,
            });
        },
    },
];
